import { useEffect } from "react";

import { disableAudioModalMessage } from "../store/audio-slice";
import { setIosOrMacOsPlatform } from "../store/config-slice";
import { useAppDispatch } from "../store/hooks";

import { isIosOrMacOsPlatform } from "../utils";

export const useCheckOperatingSystem = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isIosOrMacOsPlatform()) {
      dispatch(setIosOrMacOsPlatform(true));
      dispatch(disableAudioModalMessage(true));
    }
  }, [dispatch]);
};
